export default class AdminController
{
	constructor($http, $scope, AppService) {
		// Dependancies
		this.$http = $http;
		this.$scope = $scope;
		this.AppService = AppService;
		this.success = false;

		this.$scope.$parent.title = this.title;

		this.attributes = {
			date_visited: null,
			volume: null,
			visitor_type: null,
			visitor_origin: null,
			country: null,
			postcode: null,
			organisation: null,
			accommodation: null,
			transport_type: null,
			airline: null,
			referral: null,
			advertisement: null
		};

		this.getFilterOptions();
	}

	get title() {
		return 'Administration';
	}

	submit() {
		var _this = this;
		this.$scope.validate = function(e) {
			if (this.addTouristForm.$invalid) {
				return false;
			} else {
				_this.$http({
					method: 'POST',
					url: '/api/admin/add',
					data: _this.attributes
				}).then(
					(response) => {
						// Reset form
						this.addTouristForm.$setPristine(true);
						_this.attributes = {};
						_this.success = true;
					},
					(response) => {
						alert('Unable to add tourist data');
						console.log(response);
					}
				);
			}
		};
	}

	getFilterOptions() {
		this.$http({
			method: 'GET',
			url: '/api/custom/lists',
			headers: {
				'Content-Type': 'application/json'
			}
		}).then(
			(response) => {
				this.filterOptions = response.data.data;
			},
			(response) => {
				alert('Unable to get filter options');
				console.log(response);
			}
		);
	}
}



/** WEBPACK FOOTER **
 ** ./resources/assets/js/controllers/admin.controller.js
 **/